import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { getUserLocation, getLocationName } from '../services/firebase/geolocation';
import '../styles/global.css';
import '../styles/Header.css';

const Header = ({ openAuthModal, user }) => {
  const location = useLocation();
  const [locationName, setLocationName] = useState('');
  const [localDate, setLocalDate] = useState('');

  useEffect(() => {
    const fetchLocation = async () => {
      try {
        const userLocation = await getUserLocation();
        const name = await getLocationName(userLocation.latitude, userLocation.longitude);
        setLocationName(name);
        
        const date = new Date();
        const options = { 
          weekday: 'long',
          year: 'numeric',
          month: 'long',
          day: 'numeric',
          timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone
        };
        setLocalDate(date.toLocaleDateString('en-US', options));
      } catch (error) {
        console.error('Error fetching location:', error);
        setLocationName('Unknown Location');
      }
    };
    
    fetchLocation();
  }, []);

  const handleProtectedClick = (e, path) => {
    if (!user && ['/profile', '/write', '/bookmarks'].includes(path)) {
      e.preventDefault();
      openAuthModal();
    }
  };

  const isAdmin = user && user.email === 'ana9non@gmail.com';

  return (
    <>
      <div className="header-wrapper">
        <div className="header">
          <div className="header-content">
            <div className="header-ad-container">
              <div className="header-ad">Ad Space</div>
              <div className="logo-area">
                <Link to="/">
                  <img src="/images/logo.png" alt="MyColu" className="logo-image" />
                </Link>
              </div>
              <div className="header-ad">Ad Space</div>
            </div>
          </div>

          <div className="nav-container">
            <div className="header-top-info">
              <span className="location-info">
                <svg 
                  className="location-icon" 
                  width="16" 
                  height="16" 
                  viewBox="0 0 24 24" 
                  fill="black"
                >
                  <path d="M12 0C7.802 0 4 3.802 4 8.5c0 7.093 8 15.5 8 15.5s8-8.407 8-15.5C20 3.802 16.198 0 12 0zm0 11a2.5 2.5 0 110-5 2.5 2.5 0 010 5z"/>
                </svg>
                {locationName || 'Loading...'}
              </span>
              <span className="date-info">{localDate}</span>
            </div>
            <div className="line-image-above-nav" style={{ backgroundImage: `url('/images/line3.png')` }}></div>
            <nav className="nav">
              <ul className="nav-list">
                <li className="nav-item"><Link to="/">HOME</Link></li>
                <li className="nav-item">
                  <a href="/bookmarks" onClick={(e) => handleProtectedClick(e, '/bookmarks')}>
                    <img src="/images/bookmarks.png" alt="Bookmarks" className="nav-icon bookmark-icon" />
                  </a>
                </li>
                <li className="nav-item write-center">
                  <a href="/write" onClick={(e) => handleProtectedClick(e, '/write')}>
                    <img src="/images/write.png" alt="Write" className="nav-icon write-icon" />
                  </a>
                </li>
                <li className="nav-item">
                  <Link to="/ad">ADs</Link>
                </li>
                <li className="nav-item">
                  {user ? (
                    <div className="user-menu">
                      <Link to="/profile">MY COLUMN</Link>
                      {isAdmin && (
                        <Link to="/admin" className="admin-link">ADMIN</Link>
                      )}
                    </div>
                  ) : (
                    <button
                      className="auth-button"
                      onClick={openAuthModal}
                      style={{
                        background: 'none',
                        border: 'none',
                        color: '#333',
                        fontWeight: 'bold',
                        cursor: 'pointer'
                      }}
                    >
                      LOGIN
                    </button>
                  )}
                </li>
              </ul>
            </nav>
            <div className="line-image-below-nav" style={{ backgroundImage: `url('/images/line4.png')` }}></div>
          </div>
        </div>
      </div>
      <div style={{ height: '185px' }}></div>
    </>
  );
};

export default Header;
